const prefixDigit = digit => {
  return digit < 10 ? `0${digit}` : digit
}

const millisToDate = milliseconds => {
  const addedDate = new Date(milliseconds)

  return `${addedDate.getFullYear()}-${prefixDigit(
    addedDate.getMonth() + 1
  )}-${prefixDigit(addedDate.getDate())} ${prefixDigit(
    addedDate.getHours()
  )}:${prefixDigit(addedDate.getMinutes())}`
}

export default millisToDate



// WEBPACK FOOTER //
// ./src/utils/millisToDate.js